exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".envelope-list[data-v-3a29cf6a]{max-height:24rem;overflow-y:auto;overscroll-behavior:contain}", ""]);

// exports
